import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const getClients = {
    namespaced: true,
    state: {
        dataReceive: [],
        pagination: {
            page: 1,
            rowsPerPage: 10,
            totalItems: null,
            sortBy: [""],
            sortDesc: [""],
            current: 1,
        },
        sortBy: [""],
        sortDesc: [""],
        headers: [],
        totalItems: 0,
        paginationSecond: {},
        requestIterator: 0,
        headersPost: {},
        headersSecond: [],
        loadingClients: false
    },
    mutations: {
        GET_CLIENT_SUCCESS(state, response) {
            state.dataReceive = response.data.data;
            if(response.data.meta !== undefined) {
                state.pagination = {
                    sortBy: state.sortBy,
                    sortDesc: state.sortDesc,
                    page: state.pagination.page,
                    rowsPerPage: response.data.meta.per_page,
                    totalItems: response.data.meta.total
                }
            }
            eventBus.$emit("getClientsSuccess", state.dataReceive);
        },
        GET_CLIENT_ERROR(state, error) {
            console.log(error);
        },
        GET_HEADERS_TABLE_SUCCESS(state, response) {
            if(state.headersPost.selectTypeClient) {
                state.headersSecond = response.data;
            }
            response.data.forEach(el => el.class = "table-headers");
            state.headers = response.data;
            eventBus.$emit("getHeadersSuccess");
        },
        GET_HEADERS_TABLE_FAILURE(error) {
            console.log(error);
        }
    },
    actions: {
        getClients({dispatch, state}, page) {
            if(state.paginationSecond !== page.valueSearch)
            {
                state.paginationSecond = page.valueSearch;
                let queryParams = {};
                let clientsUrl = config.baseURLApi + "/clients";

                if (page.valueSearch) {
                    let page_number = page.valueSearch.page || state.pagination.page;
                    let rowsPerPage = page.valueSearch.itemsPerPage || state.pagination.rowsPerPage;
                    let sortDesc = page.valueSearch.sortDesc || state.pagination.sortDesc;
                    let sortBy = (page.valueSearch.sortBy !== undefined && page.valueSearch.sortBy.length !== 0) ? page.valueSearch.sortBy : state.pagination.sortBy;
                    let language = page.valueSearch.language;
                    let clientType = page.valueSearch.clientType;
                    let name = page.valueSearch.name;
                    let current_page = page.valueSearch.filters === true ? 1 : null;

                    queryParams = {
                        page: page_number,
                        rowsPerPage: rowsPerPage,
                        language,
                        sortBy: sortBy[0],
                        sortDesc: sortDesc[0],
                        clientType,
                        current_page,
                        name
                    };

                    clientsUrl = config.baseURLApi + "/clients";
                    state.sortBy = sortBy;
                    state.sortDesc = sortDesc;
                }

                state.loadingClients = true;
                eventBus.$emit("setDisablePagination", true);
                var promise = sendRequest("get", clientsUrl, {}, {}, true, queryParams);
                promise.then(function ($result) {
                    if ($result[0] === "success") {
                        dispatch("successGetClient", $result[1]);
                    } else {
                        dispatch("errorGetClient", $result[1]);
                    }
                    state.loadingClients = false;
                    eventBus.$emit("setDisablePagination",false);
                });
            }
        },
        getHeadersTable({ dispatch }) {
            var headers = {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+localStorage.getItem("tokenAuth")
            };
            var promise = sendRequest("get", config.baseURLApi+"/clients/tableHeaders/getClientsTableHeaders", headers);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetHeadersTable", result[1]);
                } else {
                    dispatch("failureGetHeadersTable", result[1]);
                }
            });
        },
        getHeadersTableSecond({ state }, payload) {
            var headers = {
                "Content-Type": "application/json",
                "Authorization": "Bearer "+localStorage.getItem("tokenAuth")
            };
            if(payload.creds.selectTypeClient) {
                state.headersPost.selectTypeClient = payload.creds.selectTypeClient
            }
            var promise = sendRequest("get", config.baseURLApi+"/clients/tableHeaders/getClientsTableHeaders", headers, {}, true, state.headersPost);
            promise.then(function(result) {
                if(result[0] === "success") {
                    result[1].data.forEach(el => el.class = "table-headers");
                    state.headersSecond = result[1].data;
                } else {
                    console.log(result[1]);
                }
            });
        },
        successGetHeadersTable: function({ commit }, response) {
            commit("GET_HEADERS_TABLE_SUCCESS", response);
        },
        failureGetHeadersTable: function({ commit }, error) {
            commit("GET_HEADERS_TABLE_FAILURE", error);
        },
        successGetClient: function({ commit }, response) {
            commit("GET_CLIENT_SUCCESS", response);
        },
        errorGetClient: function({ commit }, error) {
            commit("GET_CLIENT_ERROR", error);
        }
    }
}

export default getClients;